/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     首页 API 接口
  | @Version:   2019-03-18  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST


export function godTodoListApi(params) {
  return request({
    url: `${jsApiHost}/god/todo/list`,
    method: 'get',
    params
  })
}

export function godAuthGetApi(params) {
  return request({
    url: `${jsApiHost}/god/todo/rms/auth/get`,
    method: 'get',
    params
  })
}

export function godTodoOrderGetApi(params) {
  return request({
    url: `${jsApiHost}/god/todo/ei/order/get`,
    method: 'get',
    params
  })
}

export function godTodoRecoverGetApi(params) {
  return request({
    url: `${jsApiHost}/god/todo/recover/get`,
    method: 'get',
    params
  })
}

export function godTodoAuthPost(data) {
  return request({
    url: jsApiHost + '/god/todo/rms/auth/post',
    method: 'post',
    data: data
  })
}

export function godTodoShopShipping(data) {
  return request({
    url: jsApiHost + '/god/todo/shop/shipping',
    method: 'post',
    data: data
  })
}

export function godTodoRecoverPost(data) {
  return request({
    url: jsApiHost + '/god/todo/recover/post',
    method: 'post',
    data: data
  })
}